import React, { useEffect, useState } from 'react'
import { Container, Row, Col, Button, Form } from 'react-bootstrap'
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from 'react-redux'
import useAuth from '../../../context/auth/useAuth'
import { Link, useParams } from 'react-router-dom'
import { editRestaurant, getRestaurant, enableRestaurant, disableRestaurant } from '../../../actions/restaurantsActions'
import Swal from 'sweetalert2'

export default function RestaurantsEdit() { 
  	const { t } = useTranslation()
	const dispatch = useDispatch()
	const {client} = useAuth()

    const { id } = useParams()

	const {restaurant, resultrestaurant} = useSelector(state=>state.restaurants)

    const [dataRestaurants, setDataRestaurants] = useState({ drinkIncluded: true })
    const [isEditing, setIsEditing] = useState(false)
    const [imageAux, setImage] = useState(null)

	useEffect(() => {
		if(client){
			dispatch(getRestaurant(id))
		}
	},[dispatch, t, client, id])

    useEffect(()=>{
        if (restaurant) {
            setDataRestaurants(restaurant)
			setImage(restaurant.photo)
        }
    }, [restaurant, client, dispatch])

    const handleInputChange = ({target})=>{
        setDataRestaurants({
            ...dataRestaurants,
            [target.name]: target.value
        })
    }
    const handleCheckboxChange = ({target}) => {
        setDataRestaurants({
            ...dataRestaurants,
            [target.name]: target.checked
        })
    }

    const handleInputScheduleChange = async(day, e) => {
        e.preventDefault()

        setDataRestaurants({
            ...dataRestaurants,
            schedule: {
                ...dataRestaurants.schedule,
                [day]: {
                    ...dataRestaurants.schedule[day],
                    [e.target.name]: e.target.value
                }
            }
        })
    }

    const handleImage = (e)=>{
		setImage(e.target.files[0])
    }

    const handleEdit = async(e) => {        
        e.preventDefault()
        setIsEditing(true)
        dispatch(editRestaurant(imageAux, dataRestaurants, id))
        setIsEditing(false)
    }

    const disableEnableRestaurants = async(e) => {
        e.preventDefault()
        let textQuestion = ''
        dataRestaurants.active
            ?
                textQuestion = t('admin.restaurants.areyousuredisable')+'<br><p><label className="fs-20 fw-600 pt-5">'+dataRestaurants?.name+'</label></p>'
            :
                textQuestion = t('admin.restaurants.areyousureenable')+'<br><p><label className="fs-20 fw-600 pt-5">'+dataRestaurants?.name+'</label></p>'

        Swal.fire({
            showConfirmButton: true,
            showDenyButton: true,
            confirmButtonText: t('global.accept'),
            denyButtonText: t('global.cancel'),
            html: textQuestion
        }).then((result) => {
            if (result.isConfirmed) {
                if (dataRestaurants.active) {
                    dispatch(disableRestaurant(dataRestaurants._id))
                }else{
                    dispatch(enableRestaurant(dataRestaurants._id))
                }
            }
        })
    }

    useEffect(() => {
        if(resultrestaurant){
            switch (resultrestaurant) {
                case 'success':
                    Swal.fire({
                        showConfirmButton: true,
                        showDenyButton: false,
                        confirmButtonText: t('global.great'),
                        icon: 'success',
                        text: t('admin.restaurants.restaurantedit')
                    })
                    break;
                default:
                    break;
            }
        }
    // eslint-disable-next-line
    }, [resultrestaurant])

	return (
        <Container className='p-5'>
            <Row className="mb-3">
                <Col xs={2} className='p-0'>
                    <Link className="p-0 my-3" to="/admin/restaurants">
                        <img src="../../images/arrow-back.svg" alt="arrow-back" width={25}></img>
                    </Link>
                </Col>
                <Col xs={8} className='text-center'>
                    <h1 className='fs-18'>{t('admin.restaurants.editrestaurant')}</h1>
                </Col>
                <Col xs={2}></Col>
            </Row>
            <Row className="mt-5">
                <Form className="px-4 formulario" onSubmit={handleEdit}>
                    <Row className="text-center mt-3">
                        <h2 className="sd-label text-start">{t('admin.restaurants.namerestaurant')}</h2>
                    </Row>
                    <Row className="text-center mb-3 row-eye">
                        <Form.Control
                            className="sd-input"
                            type='text'
                            name='name' 
                            value={dataRestaurants?.name ||  ''}
                            placeholder={t('admin.restaurants.setname')}
                            onChange={handleInputChange}
                            required
                        />
                        <img className="sd-imageneye" src="../../images/pencil.svg" alt="pencil" width={15}></img>
                    </Row>
                    <Row className="text-center mt-3">
                        <h2 className="sd-label text-start">{t('admin.restaurants.addressrestaurant')}</h2>
                    </Row>
                    <Row className="text-center mb-3 row-eye">
                        <Form.Control
                            className="sd-input"
                            type='text'
                            name='address' 
                            value={dataRestaurants?.address || ''}
                            placeholder={t('admin.restaurants.setaddress')}
                            onChange={handleInputChange}
                            required
                        />
                        <img className="sd-imageneye" src="../../images/pencil.svg" alt="pencil" width={15}></img>
                    </Row>
                    <Row className="text-center mt-3">
                        <h2 className="sd-label text-start">{t('admin.restaurants.drinksincluded')}</h2>
                    </Row>
                    <Row>
                        <Form.Check
                            className="ms-3"
                            type="switch"
                            name="drinkIncluded"
                            onChange={handleCheckboxChange}
                            checked={dataRestaurants?.drinkIncluded || false}
                        />
                    </Row>
                    <Row className="text-center mt-3 align-items-center">
                        <h2 className="sd-label text-start fs-16 fw-400">{t('admin.restaurants.schedulerestaurant')}*</h2>
                    </Row>
                    {['monday', 'tuesday','wednesday', 'thursday', 'friday', 'saturday', 'sunday'].map((day,key) => (
                        <Row className="text-center mb-3 align-items-center" key={key}>
                            <Col>{t('admin.restaurants.'+day)}</Col>
                            <Col className='p-0'>
                                <Form.Control
                                    className="sd-input"
                                    type='time'
                                    name='scheduleopen'
                                    //eslint-disable-next-line
                                    value={eval(`dataRestaurants?.schedule?.${day}?.scheduleopen`) || ''}
                                    onChange={(e) => handleInputScheduleChange(day, e)}
                                    required
                                />
                            </Col>
                            <Col xs={1}>-</Col>
                            <Col className='p-0'>
                                <Form.Control
                                    className="sd-input"
                                    type='time'
                                    name='scheduleclose'
                                    //eslint-disable-next-line
                                    value={eval(`dataRestaurants?.schedule?.${day}?.scheduleclose`) || ''}
                                    onChange={(e) => handleInputScheduleChange(day, e)}
                                    required
                                />
                            </Col>
                        </Row>
                    ))}
                    <Row className="text-center my-3">
                        <h2 className="sd-label text-start fs-16 fw-400">{t('admin.restaurants.setimage')}</h2>
                        <Form.Control
                            className="sd-input"
                            type='file'
                            name='image'
                            onChange={handleImage}
                        />
                        {imageAux
                            ?
                                <img className="img-restaurant" alt="Preview" src={typeof imageAux === 'string' ? imageAux : URL.createObjectURL(imageAux)} />
                            :
                                dataRestaurants?.photo
                                    ?
                                        <img className="img-restaurant" alt="Preview" src={typeof dataRestaurants?.photo === 'string' ? dataRestaurants?.photo : URL.createObjectURL(dataRestaurants?.photo)} />
                                    :
                                        <div className="img-restaurant"></div>
                        }
                    </Row>
                    <Row className="text-center my-3">
                        <Col>
                            <Button variant='primary' type="submit" className="btn-primary w-100 my-2">
                            {isEditing
                                ?
                                    <>
                                        <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                    </>
                                :
                                    <>{t('admin.restaurants.update')}</>
                            }
                            </Button>
                            <Button type="button" className="btn-fourth w-100 my-3" onClick={(e) => disableEnableRestaurants(e)}>
                                <label className='label-button'>{dataRestaurants?.active ? t('admin.restaurants.disable') : t('admin.restaurants.enable')}</label>
                            </Button>
                        </Col>
                    </Row>
                </Form>
            </Row>
        </Container>
	)
}